




































import Vue from 'vue'
import InputWithValidation from '@/components/globals/basics/InputWithValidation.vue'
import { ValidationObserver } from 'vee-validate'
import { ValidationError } from '@/externals/gyym/client'

export default Vue.extend({
  name: 'PasswordRecoveryForm',
  components: {
    InputWithValidation,
    ValidationObserver,
  },
  props: {
    asyncErrors: {
      type: Object as () => ValidationError,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: this.$store.getters['auth/user'].email || '',
    }
  },
  watch: {
    asyncErrors(errors) {
      // @ts-ignore
      this.$refs.observer.setErrors(errors)
    },
  },
})
